import { makeStyles } from '@material-ui/core/styles';

const SidebarMenuDetailsUseStyles = makeStyles(theme => ({
  SidebarMenuDetails: {
    '&__table': {
      position: 'absolute',
      top: 54,
      left: '50%',
      transform: 'translateX(-50%)',
      minWidth: 450,
      maxWidth: 650,
      height: 40,
      backgroundColor: 'rgba(11, 17, 32, 0.85)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      border: '1px solid rgba(14, 165, 233, 0.12)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: 8,
      padding: 15,
      opacity: 1,
      transition: 'opacity 0.3s ease',
      '&__details': {
        position: 'fixed',
        top: 0,
        right: 0,
        width: '100%',
        maxWidth: 540,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100vh',
        overflow: 'hidden',
        background: 'rgba(11, 17, 32, 0.92)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderLeft: '1px solid rgba(14, 165, 233, 0.1)',
        '&__filters': {
          position: 'relative',
          width: '100%',
          padding: '5px 15px 0 0',
        },
        '&__timeline': {
          position: 'relative',
          width: '100%',
          padding: '15px 15px 5px 0',
        },
        '&__scroll': {
          padding: '5px 0',
          height: '100%',
          maxHeight: 250,
          margin: '5px 0',
          overflowY: 'auto',
        },
        '&__container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          '&__button': {
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(14, 165, 233, 0.2) !important',
            backgroundColor:
              theme.palette.dashboard.filters.buttonBackgroundColor,
            color: theme.palette.dashboard.filters.buttonColor,
            margin: 5,
            width: 150,
            height: 50,
            '&--big': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            },
          },
        },
      },
    },
    '&__list': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&__item': {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '6px',

        '&__icon': {
          minWidth: 36,
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 36,
          color: theme.palette.white,
          borderRadius: '6px',
          transition: 'opacity 0.2s ease, background-color 0.2s ease',
          '& svg': {
            width: 24,
            height: 24,
          },
        },
        '&__text': {
          margin: '0 15px',
          color: theme.palette.white,
          transition: 'color 0.2s ease',
          fontSize: 12,
          fontWeight: 600,
        },
        '&:hover': {
          cursor: 'pointer',
        },
        '&:hover &__icon, &.active &__icon': {
          opacity: 1,
          backgroundColor: 'rgba(6, 182, 212, 0.15)',
          color: '#06B6D4',
        },
        '&:hover &__text': {
          color: '#06B6D4',
        },
      },
    },
  },
}));

export { SidebarMenuDetailsUseStyles };
